"use strict";
const bd = {
    LuckyPickSlots: "লাকি পিক স্লট",
    WithdrawalPage: {
        ImportantNotice: "গুরুত্বপূর্ণ বিজ্ঞপ্তি",
        ShowLess: "কম দেখান",
        IM1: "আপনার লেনদেন 10 মিনিটের বেশি সময় ধরে পেন্ডিং থাকলে অনুগ্রহ করে আমাদের <b>24/7 সরাসরি কথোপকথন</b>-এর সাথে যোগাযোগ করুন।",
        IM2: "উত্তোলনের ব্যাংক অ্যাকাউন্টের নাম নিবন্ধিত পুরো নামের সাথে মিল থাকতে হবে; সদস্যকে তৃতীয় পক্ষের ব্যাংক অ্যাকাউন্টে উত্তোলন করার অনুমতি নেই।",
        IM3: "কিছু গেম প্রদানকারীর রিপোর্ট সিঙ্ক করতে 15–30 মিনিট সময় প্রয়োজন হয়, অনুগ্রহ করে প্রয়োজনীয় সিঙ্ক সময়ে ধৈর্য ধরুন।",
        IM4: "অসুবিধা এড়াতে উত্তোলনের লেনদেন করার আগে অনুগ্রহ করে নিশ্চিত করুন যে আপনার টার্নওভার প্রয়োজনীয়তা পূরণ হয়েছে।",
        IM5: "যদি কোনো গরমিল থাকে বা উত্তোলন সংক্রান্ত আরও কোনো জিজ্ঞাসা থাকে, তাহলে অনুগ্রহ করে আমাদের <b>24/7 সরাসরি কথোপকথন</b>-এর সাথে যোগাযোগ করুন। ধন্যবাদ।",
    },
    FastGames: "দ্রুত গেম",
    CustomBannerSliderTitle: "সর্বশেষ আপডেট",
    DepositOptions: "আমানত বিকল্প",
    WithdrawalOptions: "উত্তোলন বিকল্প",
    CryptoAddress: "ক্রিপ্টো ঠিকানা",
    CryptoAddressRequired: "অনুগ্রহ করে ক্রিপ্টো ঠিকানা লিখুন।",
    UserId: "ইউজার আইডি",
    WinloseAmt: "জয় হারের পরিমাণ",
    Free: "বিনামূল্যে",
    InvitationAcception: "আমন্ত্রণ গ্রহণ",
    Message: "বার্তা",
    Referral: "রেফারেল",
    Profile: "প্রোফাইল",
    MyProfile: "আমার প্রোফাইল",
    AffShareHappinessMsg: '[COMPANYNAME]-এ স্বাগতম! আপনার বন্ধু আপনাকে [COMPANYNAME]-এ মজা করার জন্য আমন্ত্রণ জানিয়েছে৷ নিচের লিঙ্কে ক্লিক করুন এবং এখনই BDT [DEPOSITAMT] জমা করার সময় [মুদ্রা] [বোনস্যামট] উপভোগ করুন! আমরা আপনার সাথে উত্তেজনাপূর্ণ অফার শেয়ার করার জন্য অপেক্ষা করতে পারি না।',
    AffShareOfferTitle: 'আপনার প্রিয় অফার আপনার বন্ধুদের সাথে শেয়ার করুন!',
    AffShareHapinessTitle: 'আপনার বন্ধুর সাথে সুখ ভাগ করুন',
    AffShareHapinessDesc: 'আপনার বন্ধু আপনার রেফারেল কোড ব্যবহার করে সাইন আপ করলে এক্সক্লুসিভ রেফারেল বোনাস পান।',
    YourReferralStatus: "আপনার রেফারেল স্ট্যাটাস",
    InviteFriend: "বন্ধুকে আমন্ত্রণ জানান",
    ReferralLink: "রেফারেল লিঙ্ক",
    FullName: "পুরো নাম",
    NoFileChosen: "কোনো ফাইল বেছে নেওয়া হয়নি",
    voucher: "ভাউচার",
    MyReferral: "আমার রেফারেল",
    MyBonus: "আমার বোনাস",
    PersonalInformation: "ব্যক্তিগত তথ্য",
    CurrentPassword: "বর্তমান পাসওয়ার্ড",
    NewPassword: "নতুন পাসওয়ার্ড",
    ConfirmNewPassword: "নতুন পাসওয়ার্ড নিশ্চিত করুন",
    ProductTabContent: {
        SportHeaderTitle: 'খেলাধুলার বই',
        SportHeaderDesc: '35,000 টিরও বেশি লাইভ ম্যাচ সহ সেরা সম্ভাবনা।',
        SlotHeaderTitle: 'স্লট গেম',
        SlotHeaderDesc: 'সবচেয়ে ব্যাপক এবং হটেস্ট স্লট গেম।',
        CasinoHeaderTitle: 'লাইভ ক্যাসিনো',
        CasinoHeaderDesc: 'সবচেয়ে ব্যাপক এবং হটেস্ট লাইভ ক্যাসিনো।。',
        FishHeaderDesc: 'আপনার প্রিয় মাছ ধরার গেম এখানে।',
        MobileHeaderDesc: 'আপনার প্রিয় প্রদানকারী চয়ন করুন!'
    },
    ProductPage: {
        SportHeaderTitle: 'আপনার পছন্দের প্রদানকারী বেছে নিন!',
        CasinoHeaderTitle: 'রোমাঞ্চকর লাইভ ক্যাসিনো গেমস!',
        SlotHeaderTitle: 'আপনার পছন্দের প্রদানকারী বেছে নিন!',
        LotteryHeaderTitle: 'লটারি দিয়ে এটি বড় করুন!',
        FishingHeaderTitle: 'আপনার প্রিয় ফিশিং গেম এখানে আছে',
        MobileHeaderTitle: 'সুপার স্লট যা জয় করা সহজ',
        Lottery4DHeaderTitle: 'বাজারে সবচেয়ে দ্রুত এবং সর্বোচ্চ 4D লটারি পেআউট',
        CockFightHeaderTitle: 'দুর্দান্ত লড়াই গেম!',
        CricketHeaderTitle: 'অসাধারণ ক্রিকেট গেম!'
    },
    MoreApplications: "আরো আবেদন",
    LessApplications: "ਘੱਟ ਐਪਲੀਕੇਸ਼ਨਾਂ",
    livetransaction: "**লাইভ লেনদেন",
    LuckySpin: "লাকি স্পিন",
    LuckyBox: "ভাগ্যবান বাক্স",
    luckyspin_lexin: "LEX SPIN",
    AffiliateLinkInfo: "অধিভুক্ত তথ্য",
    OKContinue: "চালিয়ে যেতে ওকে ক্লিক করুন.",
    PleaseTopup: "আপনার পুরস্কার পেতে টপআপ করুন.",
    PressRefreshAfterPlay: "খেলার পরে রিফ্রেশ টিপুন",
    Example: "উদাহরণ",
    InvalidPassword: "অবৈধ পাসওয়ার্ড.",
    BirthdayReward: "জন্মদিনের পুরস্কার",
    Close: "বন্ধ",
    CashRebateReward: "নগদ রিবেট পুরস্কার",
    Rebate: "রিবেট",
    LuckySpinReward: "লাকি স্পিন পুরস্কার",
    DailyLoginReward: "দৈনিক লগইন পুরস্কার",
    PlayerRegisterReward: "প্লেয়ার রেজিস্টার পুরস্কার",
    ForgotPIN: "পিন রিসেট করুন",
    Guide: "গাইড",
    PleaseEnterPIN: "অনুগ্রহ করে পিন লিখুন.",
    PleaseSetupPIN: "আপনার পিন সেট আপ করুন.",
    PIN_6DIGIT: "অনুগ্রহ করে ৬ সংখ্যার পিন লিখুন।",
    PIN_NOT_MATCH: "PIN মেলে না, অনুগ্রহ করে PIN আবার লিখুন.",
    INVALID_PIN: "অবৈধ পিন৷.",
    PIN: "পিন লিখুন",
    RePIN: "PIN আবার লিখুন",
    days: 'দিন(s)',
    hours: 'ঘন্টা(s)',
    minutes: 'মিনিট(s)',
    Remaining: 'অবশিষ্ট',
    RemainingTime: 'অবশিষ্ট সময়',
    VoucherEmptyMsg: 'আমরা দুঃখিত, এই মুহূর্তে কোনো ভাউচার উপলব্ধ নেই৷',
    StartIn: 'শুরু হবে',
    BonusQuantityExceeded: 'সমস্ত বোনাস রিডিম করা হয়েছে, অনুগ্রহ করে অন্য প্যাকেজ নির্বাচন করুন.',
    AboutUs: "আমাদের সম্পর্কে",
    InfoCentre: "তথ্য কেন্দ্র",
    Details: "বিস্তারিত",
    ApplyNow: 'এখনি আবেদন করুন',
    ClaimNow: 'এখনই দাবি করুন',
    Claimed: 'দাবি করেছে',
    InformationCentre: "তথ্য কেন্দ্র",
    MostPlayedMonth: "গরম গেম",
    TopLiveCasino: "শীর্ষ লাইভ ক্যাসিনো",
    YoutubeVideos: "ইউটিউব ভিডিওগুলো",
    PopularSlotGames: "জনপ্রিয় স্লট গেম",
    Monthly: "মাসিক",
    Rank: "পদমর্যাদা",
    Turnover: "টার্নওভার",
    Prizes: "পুরস্কার",
    PrizeName: "পুরস্কারের নাম",
    PrizeInfo: "পুরস্কারের তথ্য",
    Month: "মাস",
    Year: "বছর",
    Search: "অনুসন্ধান করুন",
    ReadNext: "পরবর্তী পড়ুন",
    Rewards: "পুরস্কার",
    WinOver: "উইনওভার",
    Rollover: "রোলওভার",
    Retrieve: "পুনরুদ্ধার করুন",
    Form: {
        RememberMe: "আমাকে মনে কর"
    },
    Multiplier: "গুণক",
    eSports: "ইস্পোর্টস",
    HotMatches: "হট ম্যাচ",
    ContactUs: "যোগাযোগ করুন",
    RegionAndLanguage: "অঞ্চল এবং ভাষা",
    Language: "ভাষা",
    Remarks: 'মন্তব্য',
    RP_ALERT_USERID_EXIST: 'ব্যবহারকারীর নাম আগে থেকেই আছে',
    Register: 'নিবন্ধন',
    AccountName: "হিসাবের নাম",
    BankAccountName: "হিসাবের নাম",
    BankAccountNumber: "একাউন্ট নাম্বার",
    TransferTo: "স্থানান্তর করা",
    TransferFrom: "থেকে স্থানান্তর",
    CopyAccountNumber: "অ্যাকাউন্ট নম্বর কপি করুন",
    Copy: "কপি",
    Copied: "কপি করা হয়েছে",
    Share: 'শেয়ার করুন',
    QuickDeposit: "দ্রুত জমা",
    QuickDepositNotice1: "ডিপোজিট করতে, শুধুমাত্র সেই অ্যাকাউন্টটি ব্যবহার করুন যা আমাদের সাথে নিবন্ধিত হয়েছে।",
    QuickDepositNotice2: "এইভাবে জমা করুন, ওয়েবসাইটে একটি বিজ্ঞপ্তি ফর্ম জমা দেওয়ার প্রয়োজন নেই।",
    QuickDepositNotice3: "ব্যাঙ্ক স্থানান্তরের পরে অনুগ্রহ করে লাইভচ্যাটে গ্রাহক পরিষেবাগুলিতে ব্যাঙ্ক স্লিপ পাঠান।",
    Amount: "পরিমাণ",
    ATM: "ATM স্থানান্তর",
    AccessRestricted: "সংরক্ষিত এলাকা",
    AccountInfo: "অ্যাকাউন্ট তথ্য",
    Back: "পেছনে",
    AffiliateUpline: 'এফিলিয়েট আপলাইন',
    AffTitle: 'কমিশন পেতে বন্ধুর সাথে QR কোড শেয়ার করুন',
    Receipt: "প্রাপ্তি",
    Initiated: "সূচনা করেছে",
    Accepted: "গৃহীত",
    Rejected: "প্রত্যাখ্যাত",
    Error: "ত্রুটি",
    Processing: 'প্রক্রিয়াকরণ',
    Fund: 'তহবিল',
    QuickPay: 'PayTrust',
    AccountNameIsNull: "অ্যাকাউন্টের নাম প্রয়োজন",
    AccountNoIncorrect: "অ্যাকাউন্ট নম্বরটি বৈধ নয়",
    AccountNoIsEmpty: "অ্যাকাউন্ট নম্বর প্রয়োজন নেই",
    AccountSuccessfulCreate: "অ্যাকাউন্ট সফলভাবে তৈরি করা হয়েছে",
    AcctNameIncorrect: "অ্যাকাউন্টের নামটি অবৈধ",
    AccountNumber: "একাউন্ট নাম্বার",
    BSBNo: "BSB সংখ্যা",
    PayID: "Pay ID",
    Activate: "সক্রিয় করুন",
    Adjustment: "সামঞ্জস্য",
    AdjustmentDeposit: "ম্যানুয়াল বোনাস সমন্বয়",
    AdjustmentWithdraw: "জালিয়াতির পরিমাণ কর্তন",
    AdjNoPay: "ไม่มีเงินจ่าย",
    Affiliate: "অধিভুক্ত",
    AffiliateRef: "অধিভুক্ত",
    AffiliateQR: "অধিভুক্ত QR",
    AffReport: "অ্যাফিলিয়েট রিপোর্ট",
    AffProgram: "রেফারেল প্রোগ্রাম",
    Placeholder_Affiliate: 'অ্যাফিলিয়েট আইডি / রেফারেল আইডি',
    Placeholder_AffiliateOptional: "(আপনার কাছে রেফারার না থাকলে এটি খালি রাখুন)",
    Reg_Form_Optional: "উপলভ্য হলে ঐচ্ছিক",
    All: "সব",
    AllGames: "সব খেলা",
    AmountNotCorrect: "অকার্যকর পরিমাণ",
    Android: "অ্যান্ড্রয়েড",
    AnnouncementInfo1: "",
    AnnouceInfo2: "",
    Approved: "অনুমোদিত",
    Arcades: "তোরণ",
    AreYouSure: "তুমি কি নিশ্চিত?",
    Attachment: "সংযুক্তি",
    AGENT_SCORE_NOT_ENOUGH_CREDIT: "এজেন্ট স্কোর যথেষ্ট নয়, অনুগ্রহ করে গ্রাহক পরিষেবার সাথে যোগাযোগ করুন",
    BRANCH: "শাখা",
    BROWSER_BLOCKED_POPUP: "ব্রাউজার ব্লকড পপআপ",
    Balance: "ভারসাম্য",
    Bank: "ব্যাংক",
    BankDetails: "ব্যাংক বিবরণ",
    BankInTime: "তারিখ সময়",
    BarcodeClickHere: "2D বারকোড এখানে ক্লিক করুন >>>",
    BettingCasino: "পণ (Live Casino)",
    BettingEGames: "পণ (EGames)",
    Banking: 'ব্যাংকিং',
    Others: 'অন্যান্য',
    WelcomeBonus: 'স্বাগতম বোনাস',
    BettingLottery: "পণ (Lottery)",
    BettingMSport: "পণ (M Sport)",
    BettingP2P: "পণ (P2P)",
    BettingSport: "পণ (Sport)",
    BetNow: "এখন বাজি",
    Bonus: "বোনাস",
    FishHunt: 'মাছ ধরা',
    CashFish: 'ক্যাশ ফিশ',
    CDM: "নগদ জমা",
    CFSupportDesktopOnly: "শুধুমাত্র সমর্থন পিসি",
    CITY: "শহর",
    CT_LOADING: "লোড হচ্ছে...",
    Cancel: "বাতিল করুন",
    Captcha: "ক্যাপচা",
    ChangeLanguage: "ভাষা পরিবর্তন করুন",
    ChangePassword: "পাসওয়ার্ড পরিবর্তন করুন",
    ConfirmContinue: "আপনি কি চালিয়ে যেতে চান?",
    ConfirmPassword: "পাসওয়ার্ড নিশ্চিত করুন",
    Contact: "যোগাযোগ",
    CopyUrlLink: "ইউআরএল লিঙ্ক কপি করুন",
    Copyright: "কপিরাইট",
    CopyrightText: "© [YEAR] [COMPANYNAME] কপিরাইট। সমস্ত অধিকার সংরক্ষিত",
    Currency: "মুদ্রা",
    CurrentStatus: "এখনকার অবস্থা",
    CurrentDeposit: "কারেন্ট ডিপোজিট",
    AmountRequiredForNextTierUpgrade: "পরবর্তী আপগ্রেডের জন্য প্রয়োজনীয় পরিমাণ",
    DepositLesserThan: "এর চেয়ে কম আমানত",
    MinimumDeposit: "ন্যূনতম আমানত",
    Date: "তারিখ",
    DOB: "জন্ম তারিখ",
    Daily: 'দৈনিক',
    RegisterDesc1: 'কোনো একাউন্ট এখনও নেই? ক্লিক',
    RegisterDesc2: 'নিবন্ধন করতে',
    DateFromInvalid: "প্রথম তারিখ দ্বিতীয় তারিখের চেয়ে বড় হতে হবে",
    DateToInvalid: "দ্বিতীয় তারিখ প্রথম তারিখের চেয়ে বড় হতে হবে",
    Deposit: "ডিপোজিট",
    DepositNow: "এখনই জমা দিন",
    DepositACCTNAME: "হিসাবের নাম",
    DepositAmount: "পরিমাণ",
    DepositAmountInsufficient: "জমার পরিমাণ অপর্যাপ্ত",
    DepositBank: "ডিপোজিট ব্যাংক",
    DepositDetails: "জমার বিবরণ",
    DepositError: "আমানতের বিবরণ যোগ করার সময় একটি সমস্যা হয়েছে",
    DepositType: "জমার ধরন",
    DepositToWallet: 'ওয়ালেটে জমা করুন',
    DepositorName: 'আমানতকারীর নাম',
    WithdrawFromWallet: 'ওয়ালেট থেকে প্রত্যাহার করুন',
    Download: "ডাউনলোড করুন",
    Desktop: "ডেস্কটপ",
    EGames: "ইগেম",
    Earned: "অর্জিত ($)",
    Email: "ইমেইল",
    EmailOrMobileNo: "ইমেইল বা মোবাইল নম্বর",
    EmailOrMobileNotFound: "ইমেল বা মোবাইল পাওয়া যায়নি",
    EnterVerificationCode: "আপনার যাচাইকরণ কোড লিখুন. (কোড আপনার নিবন্ধিত ফোন নম্বরে এসএমএস করবে",
    EnterVerificationCodeCustom1: "আপনার নিবন্ধিত মোবাইল নম্বরে যাচাইকরণ কোড পাঠানো হবে",
    EnterVerificationCodeCustom2: "শীঘ্রই দয়া করে লাইভ চ্যাটের মাধ্যমে আমাদের সাথে যোগাযোগ করুন যদি আপনি এটি 5 মিনিটের মধ্যে না পান।",
    Euro2020: "Euro 2020",
    WorldCup: 'World Cup ' + currentYear,
    Error_NotSupportedCurrency: "মুদ্রা সমর্থিত নয়",
    Error_OnlySupportAndroid: "শুধু অ্যান্ড্রয়েড সমর্থন করুন",
    ExtraBonus: "অতিরিক্ত বোনাস",
    EWallet: "ই-ওয়ালেট",
    FirstName: "পুরো নাম",
    FishHuntKing: "মাছ শিকার",
    ForgetPassword: "আমাদের 24 ঘন্টা অনলাইন গ্রাহক পরিষেবার সাথে যোগাযোগ করুন.",
    ForgotPassword: "পাসওয়ার্ড ভুলে গেছেন",
    ForgotUserOrPassword: "ব্যবহারকারীর নাম বা পাসওয়ার্ড ভুলে গেছেন",
    ForgotPasswordTitle: "পাসওয়ার্ড ভুলে গেছেন? রিসেট পাসওয়ার্ড পেতে আপনার সাইন-ইন ইমেল বা মোবাইল নম্বর লিখুন",
    FreeRegistration: "বিনামূল্যে নিবন্ধন",
    Games: "গেমস",
    Hi: 'ওহে',
    History: "হিস্টরি",
    Here: 'এখানে',
    Home: "হোম",
    HomeTeam: "বাড়ি",
    AwayTeam: "দূরে",
    IDD: "ID",
    DocInfo: 'নথি তথ্য',
    Doc1: 'দলিল 1',
    Doc2: 'দলিল 2',
    Doc3: 'দলিল 3',
    Internet: "ইন্টারনেট ব্যাংকিং",
    InvalidAmountSubmit: "পরিমাণ বৈধ হতে হবে",
    JoinNow: "নিবন্ধন",
    Join: "যোগদান করুন",
    Tournament: 'ပြိုင်ပွဲ',
    LAST_PACKAGE_NOT_711_PACKAGE: "আপনার শেষ ডিপোজিট বোনাস প্যাকেজটি 7/11 গেমের জন্য অনুমোদিত নয়৷ <a onclick='liveChatInc.openLiveChat(event);' tabindex='0' href='#' target='_self' style='color:#bd1b20;cursor:pointer'>অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন।</a>",
    PACKAGE_IS_BLOCKED: "প্যাকেজ অনুপলব্ধ৷ <a onclick='parent.LC_API.open_chat_window({ উত্স: `minimized` }); return false' style='color:#bd1b20;cursor: pointer'>দয়া করে আমাদের সাথে যোগাযোগ করুন৷</a >",
    RPALERT_MIN_WITHDRAWAL_AMT_DEPOSIT_PACKAGE: 'সর্বনিম্ন উত্তোলনের পরিমাণ [REPLACEVALUE] না পৌঁছানো শেষ ডিপোজিট প্যাকেজের উপর নির্ভর করে',
    RPALERT_InvalidShare1: 'অবৈধ শেয়ার। এজেন্ট শেয়ার গ্যাপ ইউনিট হল 5।',
    RPALERT_InvalidShare2: 'অবৈধ শেয়ার। এজেন্ট শেয়ার অবশ্যই 0-এর বেশি হবে।',
    LiveCasino: "লাইভ ক্যাসিনো",
    Casino: "ক্যাসিনো",
    LoginFailed: "লগইন ব্যর্থ",
    LiveChat: "সরাসরি কথোপকথন",
    ChatNow: "এখন চ্যাট",
    Loading: "লোড হচ্ছে...",
    Login: "প্রবেশ করুন",
    LoginToDeposit: "প্রবেশ করুন",
    Logout: "প্রস্থান",
    Lottery: "কেনো",
    Lottery2: "লটারি",
    VRLottery: "ভিআর লটারি",
    MainWallet: "প্রধান ওয়ালেট",
    MaxPerDayBonusExceeded: "নির্বাচিত প্যাকেজের জন্য প্রতিদিনের সর্বোচ্চ বোনাস ছাড়িয়ে গেছে, অনুগ্রহ করে অন্য প্যাকেজ নির্বাচন করুন।",
    MaxWithdrawalPerDayExceed: "প্রতিদিন সর্বোচ্চ তোলার সময় অতিক্রম করেছে",
    MaxWithdrawalAmountExceeded: "সর্বাধিক উত্তোলনের পরিমাণ ছাড়িয়ে গেছে",
    MinDeposit: "মিন.ডিপজিট",
    MaxDeposit: "সর্বোচ্চ জমার পরিমাণ",
    MinWithdrawalAmountInsufficient: "ন্যূনতম প্রত্যাহারের পরিমাণ অপর্যাপ্ত",
    MobileBanking: "মোবাইল ব্যাংকিং",
    MobileNo: "মোবাইল নাম্বার",
    More: "আরও",
    Movie: "সিনেমা",
    Games711: '7/11 গেম',
    MultiLoginSignOut: "একাধিক লগইন করার কারণে আপনি সাইন আউট হয়েছেন। আবার সাইন ইন করুন.",
    MyAccount: 'আমার অ্যাকাউন্ট',
    Membership: "সদস্যপদ",
    NAME: "নাম",
    NUMBER: "সংখ্যা",
    NUMBERS: " সংখ্যা",
    NoBankFound: "একটি ব্যাংক নির্বাচন করুন",
    News: 'খবর',
    Next: 'পরবর্তী',
    Notice: 'লক্ষ্য করুন',
    NoteTfs: 'Note: Main Wallet (Seamless)= Sexy Baccarat / Sexy Baccarat / SBO Sport / SBO Casino / PragmaticPlay / SBO Game / CQ9 / RTG / FlowGaming / BigGaming / Red Tiger / PGSoft/ WM / Jili/ KingMaker / Ludo / JDB / GD4D',
    Not_Approved: "প্রত্যাখ্যাত",
    OK: "ঠিক আছে",
    OneStopGames: 'ওয়ান স্টপ গেমস',
    OnlinePayment: "অনলাইন পেমেন্ট",
    PaymentSuccess: {
        title: "পেমেন্ট নিশ্চিত",
        desc1: "আপনার লেনদেন সফল হয়েছে!",
        desc2: "কোন অনুসন্ধান, আমাদের সাথে যোগাযোগ করুন. আমরা এখানে সাহায্য করতে এসেছি!"
    },
    OnlineBanking: "অনলাইন ব্যাংকিং",
    Ewallet: "এওয়ালেট",
    OpeningBalance: "ওপেনিং ব্যালেন্স",
    Sportbooks: 'খেলাধুলার বই',
    PBalance: "পয়েন্ট ব্যালেন্স",
    WPBalance: "WinPoint ব্যালেন্স",
    Freespin: "বিনামূল্যে ঘূর্ণন",
    Other: "অন্যান্য",
    PBonus: "বোনাস",
    PMax: "সর্বোচ্চ($)",
    PTimes: "বার(x)",
    Package: "প্যাকেজ",
    Password: "পাসওয়ার্ড",
    Pending: "বিচারাধীন",
    ResetPassword: "পাসওয়ার্ড রিসেট করুন",
    Placeholder_UserName: 'ব্যবহারকারীর নাম',
    Placeholder_Password: 'পাসওয়ার্ড',
    Placeholder_ConfirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
    Placeholder_FullName: 'পুরো নাম',
    Placeholder_Email: '"ইমেইল',
    Placeholder_ContactNumber: 'মোবাইল নাম্বার',
    Placeholder_DOB: 'আপনার জন্মদিনের তারিখ',
    Play: "খেলা",
    PlayNow: "এখন খেলুন",
    TrendingNow: "এখন জনপ্রিয়",
    TryAgain: "আবার চেষ্টা করুন",
    PlayNowMobile: "এখন খেলুন (Mobile)",
    PlayNowAGEGame: "খেলা (AG Slot)",
    PlayNowAGXIN: "খেলা (AG XIN)",
    PlayNowSBOSport: "খেলা (SBO Sport)",
    PlayNowSBOLCGame: "খেলা (SBO LC)",
    PlayNowSBOPragmatic: "খেলা (Pragmatic)",
    PlayNowSBOCQ9: "খেলা (CQ9)",
    PlayNowSBORTG: "খেলা (RTG)",
    PlayNowSBOFlowGaming: "খেলা (Flow Gaming)",
    PlayNowSBOGame: "খেলা (SBO Game)",
    PlayNowFGNetent: "খেলা (Netent)",
    PlayNowFGKiron: "খেলা (Kiron)",
    PlayNowFGMicroGaming: "খেলা (MicroGaming)",
    PlayNowFGPlayNGo: "খেলা (PlayNGo)",
    PlayNowFGQuickSpin: "খেলা (QuickSpin)",
    PlayNowBGLC: "খেলা (BigGaming LC)",
    PlayNowMGLC: "খেলা (MG LC)",
    PlayNowBGEG: "খেলা (BigGaming EG)",
    PlayNowMGEG: "খেলা (MG EG)",
    PlayerInfo: "প্লেয়ার তথ্য",
    PleaseContactUs: "আমাদের সাথে যোগাযোগ করুন.",
    PleaseLoginIn: "দয়া করে লগইন করুন",
    PleaseSelect: "অনুগ্রহ করে নির্বাচন করুন",
    PlayTech: 'PlayTech',
    ProgressiveJackpot: "প্রগতিশীল জ্যাকপট",
    Promotion: "প্রমোশন",
    Promotions: 'প্রমোশন',
    PromotionDetail: "প্রচারের বিস্তারিত",
    RPALERT1_INVALID_GAME_PARAM: "অবৈধ গেম পরম",
    RPALERT1_INVALID_TRANSFER_AMOUNT: "অবৈধ পরিমাণ",
    RPALERT1_MAX_TRANSFER_AMOUNT: "পরিমাণ বর্তমান ব্যালেন্সের সমান বা কম হতে হবে",
    RPALERT1_MIN_TRANSFER_AMOUNT: "পরিমাণ অবশ্যই 0-এর বেশি হতে হবে",
    RPALERT1_ONLY_FOR_MYR: "শুধুমাত্র MYR মুদ্রা কোডের জন্য",
    RPALERT1_UNKNOWN_ERROR: "আপনার ইন্টারনেট সংযোগ পরীক্ষা করুন এবং নিশ্চিত করুন যে ছবির আকার ছোট। সমস্যাটি স্থায়ী হলে অনুগ্রহ করে গ্রাহক সহায়তার সাথে যোগাযোগ করুন।",
    RPALERT1_USERGAME_DISABLED: "ব্যবহারকারী গেম নিষ্ক্রিয়",
    RPALERT2_ACCOUNT_SUSPEND: "দুঃখিত, অ্যাকাউন্ট স্থগিত করা হয়েছে",
    RPALERT2_PAYMENT_NOTAVAILABLE: "এই অর্থপ্রদানের পদ্ধতির জন্য এই প্রচার প্যাকেজটি উপলব্ধ নয়।",
    RPALERT2_BANK_BRANCH_EMPTY: "দয়া করে রাজ্য এবং শহরে কী বলুন",
    RPALERT2_IMG_FILE_UNSUPPORTTED: "নির্বাচিত চিত্র ফাইল সমর্থিত নয়, দয়া করে jpg/png/gif বিন্যাস সহ চিত্র ফাইল সংযুক্ত করুন।",
    RPALERT2_IMG_NOTSUPPORTSYMBOL: "চিহ্ন সমর্থিত নয় `~!@#$%^&*();:'\"<>//][]",
    RPALERT2_IMG_SAVE_Error: "ছবি সংরক্ষণ করুন ত্রুটি",
    RPALERT2_IMG_SIZE_EXCEEDED: "ছবির আকার সর্বাধিক 3MB সমর্থিত শুধুমাত্র",
    RPALERT2_IMG_TYPE: "শুধুমাত্র PNG, GIF এবং JPG সমর্থিত",
    RPALERT1_ACCOUNT_INACTIVE: "অ্যাকাউন্ট নিষ্ক্রিয়",
    RPALERT1_NO_ACCOUNT: 'কোন অ্যাকাউন্ট আইডি নেই',
    RPALERT1_ACCOUNT_SUSPEND: "অ্যাকাউন্ট সাসপেন্ড",
    RPALERT1_AMOUNT_IS_DECIMAL: "দশমিক পরিমাণ অনুমোদিত নয়",
    RPALERT1_AMOUNT_IS_GREATER_THAN_CREDIT: "অপ্রতুল ক্রেডিট",
    RPALERT1_CANNOT_TRANSFER_SAME_PLATFORM: "একই পণ্য প্ল্যাটফর্মের মধ্যে স্থানান্তর করা যাবে না",
    RPALERT1_FAILED: "ব্যর্থ",
    RPALERT1_GAMEDISABLED: "গেম নিষ্ক্রিয়",
    RPALERT1_INSUFFICIENT_AMOUNT: "ব্যালেন্স যথেষ্ট নয়",
    RPALERT3_INTERNAL_ERROR: "অভ্যন্তরীণ সার্ভার ডাউন",
    RPALERT1_INVALID_AMOUNT: "অবৈধ পরিমাণ",
    RPALERT1_NOT_NUMERIC_AMOUNT: "পরিমাণ সাংখ্যিক নয়",
    RPALERT1_NO_AMOUNT: "অনুগ্রহ করে ট্রান্সফার করার জন্য পরিমাণটি কী করুন।",
    RPALERT1_NO_CREDIT: "নো ক্রেডিট।",
    RPALERT1_NO_PLATFORM: "হস্তান্তর করার জন্য অনুগ্রহ করে পণ্য প্ল্যাটফর্ম নির্বাচন করুন।",
    RPALERT1_NULL_AMOUNT: "পরিমাণ শূন্য",
    RPALERT1_SUCCESS: "সফল",
    RPALERT1_SYSTEM_BUSY: "সার্ভার ব্যস্ত। অনুগ্রহ করে পরে আবার চেষ্টা করুন। ধন্যবাদ",
    RPALERT1_TRANSFER_FAIL: "ট্রান্সফার ব্যর্থ",
    RPALERT1_LOTTERY_PRIZE_WITHDRAWAL: 'আপনি লটারিতে জিতেছেন, অনুগ্রহ করে লাইভচ্যাটে আমাদের সাথে যোগাযোগ করুন',
    RPALERT5_BankNoMandatory: "অনুগ্রহ করে ব্যাঙ্ক নম্বর লিখুন",
    RPALERT5_BankNoMinLength: "ব্যাঙ্ক নং অবশ্যই থাকবে অন্তত ",
    RPALERT5_BSBNoMandatory: "অনুগ্রহ করে বিএসবি নম্বর লিখুন",
    RPALERT5_PayIDMandatory: "অনুগ্রহ করে পে আইডি লিখুন",
    RPALERT5_CurrencyReq: "অনুগ্রহ করে একটি মুদ্রা নির্বাচন করুন",
    RPALERT5_EmailInvalid: "অনুগ্রহ করে একটি বৈধ ইমেল ঠিকানা লিখুন",
    RPALERT5_EmailExist: "ইমেলটি ব্যবহার করা হয়েছে। অনুগ্রহ করে একটি অনন্য ইমেল ঠিকানা লিখুন",
    RPALERT5_MobileMinLength: "মোবাইল নম্বর অন্তত থাকতে হবে",
    RPALERT5_SMSVerificationMandatory: "দয়া করে ভেরিফাই কোডে কী করুন।",
    RPALERT5_SMSVerificationNumberOnly: "শুধুমাত্র নম্বর প্রয়োজন",
    RPALERT_MIN_AMOUNT_1000: 'সর্বনিম্ন পরিমাণ হতে হবে কমপক্ষে [AMOUNT]',
    RPALERT5_BankAccountNumericOnly: 'অ্যাকাউন্ট নম্বর শুধুমাত্র সাংখ্যিক গ্রহণ করে',
    RPALERT_FIRSTNAME_MIN_LENGTH: "সর্বনিম্ন দৈর্ঘ্য কমপক্ষে 3 হতে হবে",
    RPALERT_FULLNAME_MANDOTARY: "বাধ্যতামূলক পুরো নাম",
    RPALERT7_InvalidAccountLevel: "অবৈধ অ্যাকাউন্ট লেভেল",
    RPALERT_CAPTCHA: "অবৈধ ক্যাপচা।",
    RPALERT_USERID_OR_PASSWORD_INVALID: "অবৈধ ব্যবহারকারীর নাম বা পাসওয়ার্ড",
    RPALERT7_MobileNoReq: "বাধ্যতামূলক মোবাইল নম্বর",
    RPALERT_SUPPORT_ANDROID_ONLY: "শুধুমাত্র অ্যান্ড্রয়েড সমর্থন করে",
    RPALERT5_PasswordMinLength: "পাসওয়ার্ডের দৈর্ঘ্য কমপক্ষে 6 হতে হবে",
    RPALERT5_PasswordNotMatch: "পাসওয়ার্ড মেলেনি",
    RPALERT5_PasswordAlphaNumericOnly: 'পাসওয়ার্ডে অবশ্যই 6 থেকে 12 দৈর্ঘ্যের অক্ষর এবং সংখ্যা থাকতে হবে',
    RPALERT_MOBILE_EXIST: 'মোবাইল নম্বর উপলব্ধ নয়।',
    RPALERT_BANKACCNO_EXIST_DUE_TO_OTHER_ACC: 'পুরানো অ্যাকাউন্ট [REPLACEVALUE]-এ ব্যাঙ্ক অ্যাকাউন্ট বিদ্যমান। অনুগ্রহ করে গ্রাহক সহায়তার সাথে যোগাযোগ করুন।',
    RPALERT_ENTER_CAPTCHA: "দয়া করে ক্যাপচা লিখুন",
    RPALERT_ENTER_PASSWORD: "অনুগ্রহ করে পাসওয়ার্ড লিখুন",
    RPALERT_ENTER_CONFIRMPASSWORD: "আবার পাসওয়ার্ড লিখুন",
    RPALERT_ENTER_NAME: "অনুগ্রহ করে ব্যবহারকারীর নাম লিখুন",
    RPALERT7_ProductUnvailable: "পণ্য সমর্থিত নয়",
    RPALERT_PACKAGE_NOT_FOUND: "প্যাকেজ বিদ্যমান নেই",
    RPALERT_PACKAGE_NOT_SELECTED: 'অনুগ্রহ করে যেকোনো বোনাস প্যাকেজ নির্বাচন করুন',
    RPALERT7_RegisterFail: "রেজিস্ট্রেশন ব্যর্থ",
    RPALERT_USER_ID: 'ব্যবহারকারীর নাম শুধুমাত্র অক্ষর এবং সংখ্যা হতে হবে',
    RPALERT5_UsernameExistedMsg1: "অনুগ্রহ করে নিম্নলিখিতগুলি বিবেচনা করুন:",
    RPALERT5_LoginnameExisted: 'লগইন নাম ইতিমধ্যে নিবন্ধিত!',
    RPALERT5_LoginnameExisted1: 'অনুগ্রহ করে অন্য একটি বেছে নিন',
    RPALERT_SocialIDValid: 'অবৈধ সামাজিক আইডি',
    RPALERT_USERID_MANDATORY: "বাধ্যতামূলক ব্যবহারকারীর নাম",
    RPALERT_USERID_MIN_LENGTH: "সর্বনিম্ন দৈর্ঘ্য কমপক্ষে 6 হতে হবে",
    RPALERT5_UsernameMaxLength: 'সর্বোচ্চ দৈর্ঘ্য অতিক্রম করেছে।',
    RPALERT7_UsernamePasswordCannotSame: "ব্যবহারকারীর নাম এবং পাসওয়ার্ড একই হতে পারে না",
    RPALERT_VERIFICATIONFAILED: "অনুগ্রহ করে বৈধ যাচাইকরণ কোডটি কী করুন।",
    RPALERT_VERIFICATIONSMSLOCKED: "আপনার অ্যাকাউন্ট লক করা হয়েছে৷ অনুগ্রহ করে গ্রাহক পরিষেবার সাথে যোগাযোগ করুন বা আমাদের সাথে লাইভচ্যাট করুন",
    RPALERT_WALLET_LOCK: 'আপনার ডিপোজিট প্যাকেজ এই পণ্যের জন্য অনুপলব্ধ৷',
    RPALERT_INVALID_AFFILIATEID: 'অবৈধ অ্যাফিলিয়েট',
    RPALERT_SUPPORT_PC_ONLY: "দুঃখিত, আপাতত শুধুমাত্র পিসি সমর্থন করুন। সাথে থাকুন।",
    RPAlert_MinWithdrawal: "মিন. উত্তোলন ",
    RPAlert_MaxWithdrawal: "সর্বোচ্চ উত্তোলন ",
    CreditTransfer: "ক্রেডিট স্থানান্তরণ",
    CreditTransferTo: "ক্রেডিট স্থানান্তর",
    RPLocalGames: "স্থানীয় গেমস",
    RPMemberSettings: "সেটিংস নিশ্চিত করুন?",
    RPPTNT_LOGIN: "শুধুমাত্র Android সমর্থন",
    RPPTNT_LOGIN2: "আপনার জন্য শুভকামনা",
    RPPTNT_LOGIN3: "প্লেটেক অ্যাপ দিয়ে লগইন করুন",
    RPPTNT_LOGIN31: "অনুগ্রহ করে 918Kiss অ্যাপ দিয়ে লগইন করুন",
    RPPTNT_LOGIN4: "লগইন আইডি : ",
    Wallet: "ওয়ালেট",
    MyWallet: "ওয়ালেট",
    ReceiptNo: "রশীদ নং",
    RPALERT_REF_NUMBER_INVALID: 'রেফারেন্স নম্বর অবৈধ৷ শুধুমাত্র অক্ষর, সংখ্যা এবং [-] চিহ্ন থাকতে পারে',
    RefNumber: "পরিচিত সংখ্যা",
    Refresh: "রিফ্রেশ",
    RegisterDate: "নিবন্ধিত তারিখ",
    RegisterNow: "এখন নিবন্ধন করুন",
    RegistrationNotice: "টিপস: গেমিং সাইট অ্যাকাউন্ট পরিচালনা নিয়ন্ত্রণ করার জন্য, প্রতিটি সদস্য শুধুমাত্র একটি গেম অ্যাকাউন্ট নিবন্ধিত করার অনুমতি দেয়, অনুগ্রহ করে আপনার আসল নামটি পূরণ করুন, উত্তোলন বাধ্যতামূলক এবং ধারাবাহিকভাবে নিবন্ধিত নাম ব্যাঙ্ক কার্ড অপারেশন হবে, আপনার সহযোগিতার জন্য আপনাকে ধন্যবাদ।",
    RegistrationNotice2: "নীচের জমা দেওয়া বোতামে ক্লিক করুন, আপনি নিশ্চিত করুন যে আপনার বয়স 18 বছরের বেশি।",
    RememberMe: "আমাকে মনে কর",
    RollOverTarget: "টার্নওভার / টার্গেট",
    SCR888Games: "918কিস গেমস",
    Special: 'বিশেষ',
    SCRGames: "7-11 গেমস",
    HOTGames: "হট গেম",
    HotGames: "হট গেম",
    STATE: "রাষ্ট্র",
    Status: "স্ট্যাটাস",
    SessionTimeout: "সময় সময়সীমার",
    Set: "সেট",
    Settings: "সেটিংস",
    AccSettings: "Acc সেটিংস",
    SignIn: "সাইন ইন করুন",
    SlotGames: "স্লট গেম",
    SlotEGames: "স্লট ইগেমস",
    SlotMachine: "স্লট মেশিন",
    Slots: "স্লট",
    Slot: "স্লট",
    PleaseSelHowKnowUs: 'আপনি আমাদের কিভাবে জানেন',
    SocialMedia: 'সামাজিক মাধ্যম',
    SocialID: 'সামাজিক আইডি',
    SlotMachinesGames: 'স্লট মেশিন গেম',
    LiveCasinoGames: 'লাইভ ক্যাসিনো গেম',
    Sport: 'খেলা',
    Sportsbook: 'খেলা',
    Sports: 'খেলাধুলা',
    Cricket: 'ক্রিকেট',
    SpadeGames: 'স্পেড গেমস',
    Poker: "জুজু",
    Statement: "বিবৃতি",
    SocialLink: 'সামাজিক লিঙ্ক',
    Submit: "জমা দিন",
    Successful: "সফল",
    TYPE: "টাইপ",
    TableGames: "টেবিল গেম",
    TermsAndConditions: "শর্তাবলী",
    Topup: "টপআপ",
    bankfees: "ব্যাঙ্ক চার্জ",
    TNC: 'T & C',
    Total: "মোট ($)",
    TotalDownline: "মোট ডাউনলাইন",
    TotalDownlineWin: "মোট জয়",
    TotalDownlineLose: "মোট ক্ষতি",
    TotalDownlineCommission: "মোট কমিশন",
    Transaction: "দৈনিক লেনদেন রিপোর্ট",
    TransactionType: "লেনদেন প্রকার",
    Transfer: "ট্রান্সফার",
    TransferAmount: "স্থানান্তর পরিমাণ",
    TransferDateTimeInvalid: "একটি তারিখ সময় নির্বাচন করুন",
    TransferNotice: "অনুগ্রহ করে একটি ট্রান্সফার টাইপ নির্বাচন করুন",
    TransferToMSport: "ট্রান্সফার <-> ওয়ালেট",
    TransferToRPEGames: "ট্রান্সফার <-> ওয়ালেট",
    TransferType: "ট্রান্সফার টাইপ",
    UnderMaintenance: "রক্ষণাবেক্ষণের অধীনে",
    Upload: "আপলোড করুন",
    UserIdIsNull: "সদস্যের অস্তিত্ব নেই",
    UserName: "ব্যবহারকারীর নাম",
    Username: "ব্যবহারকারীর নাম",
    VE_BankAccountNotAvailable: "ব্যাঙ্ক অ্যাকাউন্ট উপলব্ধ নয়",
    RPALERT5_MandatoryBankAccount: "বাধ্যতামূলক ব্যাঙ্ক অ্যাকাউন্ট",
    ValidDownline: "বৈধ ডাউনলাইন",
    ValidLose: "বৈধ হারানো($)",
    ValidWin: "বৈধ জয়($)",
    VideoPoker: "ভিডিও জুজু",
    Welcome: "স্বাগত",
    Withdraw: "প্রত্যাহার করুন",
    WithdrawAll: "সব প্রত্যাহার করুন",
    WithdrawAllCreditToMainWallet: "মূল ওয়ালেটে সমস্ত ক্রেডিট প্রত্যাহার করুন",
    Withdrawal: "উত্তোলন",
    WithdrawalError: "প্রত্যাহারের বিবরণ যোগ করার সময় একটি সমস্যা হয়েছে",
    WithdrawalLimit: "বৈধ প্রত্যাহারের পরিমাণ 100.00 ~200000.00",
    WithdrawalTnC: "*Daily withdraw count is 3 times, if exceed daily withdraw count, you will need to pay 3% processing fee.",
    WrongAccountOrPassword: "ভুল অ্যাকাউন্ট বা পাসওয়ার্ড",
    YourAccountBalance: "আপনার অ্যাকাউন্ট ব্যালেন্স",
    accountID: "অ্যাকাউন্ট আইডি :",
    bankIdNotValid: "কোন ব্যাংক স্বীকৃত",
    bankUserNameIsEmpty: "ব্যাঙ্ক ব্যবহারকারীর নাম নেই",
    cashbalance: "নগদ ভারসাম্য: ",
    FBLogin: "ফেসবুক লগইন",
    From: "থেকে",
    imgAGFishHunt: "/Content/images/fishhunt_ag_en.png?v1",
    imgAgDeluxe: "/Content/images/AGDeluxeSuite_FA_en.jpg?v1",
    imgAllBetDeluxe: "/Content/images/AllBet_en.jpg?v1",
    imgXPGLC: "/Content/images/XPGLiveCasino_en.jpg",
    imgBetSoftEG: "/Content/images/BetSoftSlot_en.jpg",
    imgSALC: "/Content/images/SALiveCasino_en.jpg?v1",
    imgSAEG: "/Content/images/SASlot_en.jpg?v1",
    imgCockFight: "/Content/images/CockFight_en.jpg?v3",
    imgGDDeluxe: "/Content/images/GoldDeluxe_en.jpg?v3",
    imgPTFishHunt: "/Content/images/fishhunt_pt_en.png?v3",
    imgPlayTech: "/Content/images/PlaytechLiveCasino_FA_en.jpg?v3",
    imgPtGame: "/Content/images/PlaytechSlot_FA.jpg?v3",
    imgRTDeluxe: "/Content/images/RedTiger_en.jpg?v3",
    imgSBDeluxe: "/Content/images/Sunbet_en.jpg?v3",
    imgShiShiCai: "/Content/images/shishicai_en.png",
    imgSrcAGEGame: "/Content/images/AGXinGame_en.jpg?v3",
    imgSrcGame: "/Content/images/SCR888Slot_FA.jpg",
    imgSrcSpageGames: "/Content/images/SpadeGames_en.jpg",
    LoginID: "লগইন আইডি",
    loginname: "লগইন নাম: ",
    SEVEN11_NOTE: 'দ্রষ্টব্য* যদি বোনাস প্যাকেজ নির্বাচিত হওয়ার কারণে স্থানান্তর প্রত্যাখ্যান করা হয় তাহলে 711 প্ল্যাটফর্মের (918Kiss, Playboy, 3win8, Joker) জন্য অস্বীকৃতি জানানো হয়। ',
    RPALERT_PACKAGE_APPROVAL_EXIST: "একটি মুলতুবি অনুরোধ প্যাকেজ আছে",
    RPALERT_PACKAGE_NEED_DEPOSIT: "অনুগ্রহ করে তোলার আগে জমা দিন। ধন্যবাদ",
    RPALERT_RECEIPT_NO_EMPTY: "অনুগ্রহ করে রেফ নম্বর পূরণ করুন",
    RPALERT_RECEIPT_NOT_FOUND: "অনুগ্রহ করে রসিদ আপলোড করুন",
    To: "To",
    RPALERT_TRAN_DATE_NULL: "কোন স্থানান্তর তারিখ নির্বাচন করা হয়নি",
    RPALERT_ROLLOVER_LESS_THAN_TARGET_AMOUNT: "রোলওভার লক্ষ্যমাত্রার চেয়ে কম",
    RPALERT_WITHDRAW_AMT_EXCESS: "উত্তোলনের পরিমাণ বর্তমান ক্রেডিট থেকে বড়",
    RPALERT_WITHDRAWAL_VENDOR_FAILED: "বিক্রেতা থেকে প্রত্যাহার ব্যর্থ হয়েছে. পরে আবার চেষ্টা করুন",
    P2PRolloverNotMeet: '* রোলওভার নট মিট P2P ট্রান্সফার করতে পারে না',
    ViewDesktopVersion: 'ডেস্কটপ সংস্করণ দেখুন',
    DesktopVersion: 'ডেস্কটপ সংস্করণ',
    VIP: 'ভিআইপি',
    Keno: 'কেনো',
    VIPPDFDownload: 'আমাদের ভিআইপি ব্রোশার ডাউনলোড করুন',
    AffProgramPDFDownload: 'আমাদের এফিলিয়েট ব্রোশার ডাউনলোড করুন',
    BankTransfer: 'ব্যাংক লেনদেন',
    SportsbookLX: 'স্পোর্টবুক',
    LiveCasinoLX: 'লাইভ ক্যাসিনো',
    EGamesLX: 'ইগেম',
    LotteryLX: ' লটারি',
    MoreLX: 'আরও',
    MobileLX: 'মুঠোফোন',
    Facebook: "ফেসবুক",
    Instagram: "ইনস্টাগ্রাম",
    Forum: "ফোরাম",
    GoogleSearch: "Google অনুসন্ধান",
    UserNameEmail: 'ব্যবহারকারীর নাম / ইমেল',
    PleaseEnterUsernameEmail: 'অনুগ্রহ করে ব্যবহারকারীর নাম বা ইমেল লিখুন',
    RPALERT4_ResetPassFail: 'পাসওয়ার্ড ব্যর্থ রিসেট করুন। আবার চেষ্টা করুন',
    RPALERT4_ResetPassSuccess: 'পাসওয়ার্ড রিসেট সফল হয়েছে',
    ALERT_ResetPassSuccessMobileNotice: 'আপনার নতুন পাসওয়ার্ড আপনার নিবন্ধিত মোবাইল নম্বরে পাঠানো হয়েছে।',
    ALERT_ResetPassSuccessEmailNotice: 'আপনার নতুন পাসওয়ার্ড আপনার নিবন্ধিত ইমেলে পাঠানো হয়েছে।',
    ALERT_ResetPassSuccessMobileNEmailNotice: 'আপনার নতুন পাসওয়ার্ড আপনার নিবন্ধিত মোবাইল নম্বর বা ইমেলে পাঠানো হয়েছে।',
    ALERT_INVALID_OTP: "अवैध सत्यापन संकेत",
    MemberRegistration: 'সদস্য নিবন্ধন',
    RegisterMandatoryInfo: 'সমস্ত তথ্য প্রয়োজন',
    AccountInformation: 'হিসাবের তথ্য',
    UserNotFound: 'ব্যবহারকারী খুঁজে পাওয়া যায় না',
    Rated: 'রেট',
    BasedOn: 'উপর ভিত্তি করে',
    Reviews: 'পর্যালোচনা',
    PoweredBy: 'দ্বারা চালিত',
    WithdrawalName: '(প্রত্যাহার ব্যাঙ্ক অ্যাকাউন্টের মতোই।)',
    upegcom: "আপলাইন EGamesCom",
    uplccom: "Upline LiveCasinoCom",
    upftcom: "Upline FightCom",
    upllcom: "Upline LotteryCom",
    LUDOBET: "লুডো"
};
if (window.companyInfo && window.companyInfo.id == 433) {
    bd.Placeholder_UserName = 'একটি অনন্য ব্যবহারকারীর নাম';
    bd.Placeholder_Password = 'কমপক্ষে 6টি অক্ষরের পাসওয়ার্ড';
    bd.Placeholder_ConfirmPassword = 'পাসওয়ার্ড নিশ্চিত করুন';
    bd.Placeholder_FullName = 'পুরো নাম ম্যাচ ব্যাংক Acc হোল্ডার প্রত্যাহারের জন্য';
    bd.Placeholder_Email = 'বৈধ ইমেল ঠিকানা (example@domain.com)';
    bd.Placeholder_ContactNumber = '(সর্বোচ্চ 13টি সংখ্যা সহ 60)';
}
if (window.companyInfo && window.companyInfo.id == 1685) {
    bd.RefNumber = "লেনদেন নাম্বার";
    bd.WithdrawAll = "সব প্রত্যাহার";
    bd.LUDOBET = "লুডো";
}
if (window.companyInfo && window.companyInfo.id == 1707) {
    bd.RefNumber = "পরিচিত সংখ্যা /(ট্রানজেকশন আইডি)";
    bd.WithdrawAll = "সব প্রত্যাহার";
    bd.LUDOBET = "লুডো";
}
if (window.companyInfo && window.companyInfo.id == 1787) {
    bd.RefNumber = "পরিচিত সংখ্যা /(ট্রানজেকশন আইডি)";
}
